export default {
  "zh-CN": {
    fanProfile: {
      title: "粉丝资料", back: "返回粉丝列表", loading: "正在读取粉丝资料",
      noBio: "这位用户暂时没有填写简介", publicInfo: "公开资料", level: "消费等级",
      country: "国家", followedAt: "关注时间", wornTitle: "佩戴称号", notSet: "未设置",
      creatorProfile: "创作者主页", creatorProfileTip: "查看公开作品、直播和专属内容"
    },
    errors: {
      "CENTER.FANS_PERMISSION_REQUIRED": "开通短视频创作者或主播权限后才能查看粉丝",
      "CENTER.FAN_NOT_FOUND": "该粉丝关系不存在或已失效"
    }
  },
  "en-US": {
    fanProfile: {
      title: "Follower profile", back: "Back to followers", loading: "Loading follower profile",
      noBio: "This member has not added a bio yet.", publicInfo: "Public profile", level: "Spending level",
      country: "Country", followedAt: "Followed on", wornTitle: "Equipped title", notSet: "Not set",
      creatorProfile: "Creator profile", creatorProfileTip: "View public works, live streams, and exclusive content"
    },
    errors: {
      "CENTER.FANS_PERMISSION_REQUIRED": "Creator or host access is required to view followers.",
      "CENTER.FAN_NOT_FOUND": "This follower relationship is unavailable."
    }
  },
  "ar-SA": {
    fanProfile: {
      title: "ملف المتابع", back: "العودة إلى المتابعين", loading: "جارٍ تحميل ملف المتابع",
      noBio: "لم يضف هذا العضو نبذة بعد.", publicInfo: "الملف العام", level: "مستوى الإنفاق",
      country: "الدولة", followedAt: "تاريخ المتابعة", wornTitle: "اللقب المفعّل", notSet: "غير محدد",
      creatorProfile: "ملف المنشئ", creatorProfileTip: "عرض الأعمال العامة والبث والمحتوى الحصري"
    },
    errors: {
      "CENTER.FANS_PERMISSION_REQUIRED": "يلزم تفعيل صلاحية المنشئ أو المضيف لعرض المتابعين.",
      "CENTER.FAN_NOT_FOUND": "علاقة المتابعة هذه غير متاحة."
    }
  }
}
